import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OutsideClickHandler from 'react-outside-click-handler';
import allCountryCodes from 'components/configuration/country-code';
import { defaultCountryCode } from 'components/configuration/country-code';
import '../../assets/css/custom-dropdown.css';
import _ from 'lodash';

export default function PhoneNumber({
  value,
  onChange,
  countryCode,
  setCountryCode,
  placeholder,
  error,
  isInputVisible = false,
  dropdownDirection,
  flagvisibleadmin = true,
  isDisable = false
}) {
  const [dropdownStatus, setDropdownStatus] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [countryCodes, setCountryCodes] = useState();
  useEffect(() => {
    setCountryCodes(allCountryCodes);
  }, []);
  useEffect(() => {
    setCountryCodes(
      _.filter(allCountryCodes, country => {
        if (
          country.dial_code.toString().includes(searchQuery.toLowerCase()) ||
          country.name.toLowerCase().includes(searchQuery.toLowerCase())
        ) {
          return true;
        }
      })
    );
  }, [searchQuery]);
  const changeCountry = data => {
    setCountryCode(data);
    setSearchQuery('');
    setDropdownStatus(false);
  };
  const handleOutsideClick = () => {
    setSearchQuery('');
    setDropdownStatus(false);
  };
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        handleOutsideClick();
      }}
    >
      <div className="input-group">
        <div className="input-group-prepend " role="button">
          <div
            className="d-flex align-items-center form-control py-0 px-2 country-dropdown"
            onClick={isDisable ? () => { } : () => setDropdownStatus(!dropdownStatus)}
          >
            <div
              className="d-flex align-items-center"
              title={`${countryCode.name} : ${countryCode.dial_code}`}
            >
              {
                flagvisibleadmin && (
                  <img className="me-1 flag-image" src={`${process.env.REACT_APP_BASEROUTE_URL}/admin-images/country-flag/4x3/${countryCode.code.toLowerCase()}.svg`} />
                )
              }



              <span className="me-1">{countryCode.dial_code}</span>
              <FontAwesomeIcon
                icon={`${dropdownStatus ? 'caret-up' : 'caret-down'}`}
                className="ms-1"
              />
            </div>
          </div>

          {dropdownStatus && (
            <div
              className={`dropdown-options position-absolute p-2 ${dropdownDirection === 'top'
                ? 'bottom-100'
                : dropdownDirection === 'bottom' && ''
                }`}
            >
              <input
                className="form-control search-bar"
                type="text"
                placeholder="Search country"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
              {countryCodes.length > 0 ? (
                countryCodes.map((country, index) => (
                  <div
                    key={index}
                    onClick={() => changeCountry(country)}
                    className="country-name"
                    role="button"
                  >
                    <img className="me-1 flag-image" src={`${process.env.REACT_APP_BASEROUTE_URL}/admin-images/country-flag/4x3/${country.code.toLowerCase()}.svg`} />
                    <span className="me-1">{country.name}</span>
                    <span className="me-4">{country.dial_code}</span>
                  </div>
                ))
              ) : (
                <div className="text-center">
                  <h5 className="text-danger">Data not found.</h5>
                </div>
              )}
            </div>
          )}
        </div>
        {
          isInputVisible && (
            <input
              className={`form-control zindex-0 ${error ? 'is-invalid' : ''}`}
              type="text"
              value={!value ? '' : value}
              onChange={onChange}
              placeholder={placeholder}
              disabled={isDisable}
            />
          )
        }

      </div>
    </OutsideClickHandler>
  );
}
PhoneNumber.defaultProps = {
  countryCode: defaultCountryCode,
  placehoder: '',
  dropdownDirection: 'top'
};
